import React from 'react'
import styled from "styled-components"
import media from "styled-media-query"

const IntroVoices = ({ voices }) => {

    const renderVoices = voices.map((v, i) => {
        return (
            <div key={i} className="voice">
                <p className="name">{v.name}さん</p>
                <p className="where">{v.where} 合格</p>
                <p className="comment">{v.comment}</p>
            </div>
        )
    })
    

    return (
        <IntroVoicesStyles id="voices">
            <h3>合格者の声</h3>
            <div className="voicesWrap">
                {renderVoices}
            </div>
        </IntroVoicesStyles>
    )
}

const IntroVoicesStyles = styled.section`
    background-color: #fafafa;
    h3 {
        color: #FF3D01;
    }
    .voicesWrap {
        display: flex;
        justify-content: space-evenly;
        flex-wrap: wrap;
        padding-top: 40px;
        color: #6e6e6e;
        .voice {
            background-color: #fff;
            width: 45%;
            margin-top: 20px;
            padding:15px;
            border-radius: 10px;
            box-shadow: 0 3px 6px #00000070;
        ${media.lessThan("960px")`
            width: 80%;
        `}
        ${media.lessThan("600px")`
            width: 90%;
        `}
            .name {
                font-size: 2rem;
            }
            .where {
                font-size: 1.6rem;
                padding-top: 10px;
            }
            .comment {
                font-size: 1.3rem;
                padding-top: 10px;
            }
        }
    }
`

export default IntroVoices